import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'antd';

const FormMultiSelect = React.memo((props) => {
  const { label, component, name, initialValue, rules, ...rest } = props;

  return (
    <Form.Item
      label={label}
      name={name}
      initialValue={initialValue}
      rules={rules}
      {...rest}
    >
      {component}
    </Form.Item>
  );
});

FormMultiSelect.propTypes = {
  label: PropTypes.string,
  component: PropTypes.node,
  name: PropTypes.string,
  initialValue: PropTypes.any,
  rules: PropTypes.array,
};

export default FormMultiSelect;
